import { useTranslate } from "@similarweb/i18n-provider";
import { Show } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { GscKeyword } from "../../../types";

import { TooltipDivider, TooltipHintBox } from "./styles";

const PREVIEW_LIMIT = 10;

type Props = {
    keywords: GscKeyword[];
    selectedCount: number;
};

export const ShowKeywordsIcon = ({ keywords, selectedCount }: Props) => {
    const { translate } = useTranslate();

    const selectedKeywords = keywords.slice(0, selectedCount);
    const previewKeywords = selectedKeywords.slice(0, PREVIEW_LIMIT);
    const remainingCount = selectedCount - PREVIEW_LIMIT;

    const tooltipContent = (
        <Flex
            flexDirection="column"
            gap="12px"
            paddingY="4px"
        >
            <Flex
                flexDirection="column"
                gap="4px"
            >
                <Text
                    fontVariant="listItem4"
                    color={colorsPalettes.bluegrey[100]}
                >
                    {translate("rankTracker.gsc.metrics.trackedKeywords.previewTitle")}
                </Text>
                <Flex flexDirection="column">
                    {previewKeywords.map((kw) => (
                        <Text
                            key={kw.keyword}
                            fontVariant="tooltip"
                            color={colorsPalettes.bluegrey[100]}
                        >
                            {kw.keyword}
                        </Text>
                    ))}
                </Flex>
                {remainingCount > 0 ? (
                    <Text
                        fontVariant="tooltip"
                        color={colorsPalettes.bluegrey[400]}
                    >
                        {translate("rankTracker.gsc.metrics.trackedKeywords.previewMore", {
                            count: remainingCount,
                        })}
                    </Text>
                ) : null}
            </Flex>
            <TooltipDivider />
            <TooltipHintBox>
                <Text
                    fontVariant="listItem3"
                    color={colorsPalettes.bluegrey[400]}
                >
                    {translate("rankTracker.gsc.metrics.trackedKeywords.previewHint")}
                </Text>
            </TooltipHintBox>
        </Flex>
    );

    return (
        <Tooltip content={tooltipContent}>
            <Show
                data-automation="gsc-show-keywords-icon"
                size="xs"
                color={colorsPalettes.carbon[200]}
            />
        </Tooltip>
    );
};
